const sheet = {
  // 树形列表
  treeMenus: {
    type: 'post',
    url: '/ec-pc-api/report/treeMenus'
  },
  // 收藏与取消收藏
  favorite: {
    type: 'post',
    url: '/ec-pc-api/report/favorite'
  },
  // 新增文件夹
  addFolder: {
    type: 'post',
    url: '/ec-pc-api/report/addFolder'
  },
  // 更新-删除-移动文件夹
  updateFolder: {
    type: 'post',
    url: '/ec-pc-api/report/updateFolder'
  },
  // 移动-拖拽报表
  moveReport: {
    type: 'post',
    url: '/ec-pc-api/report/moveReport'
  }
};

export default sheet;
